// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chrome shared by every logged-out screen (login, password reset, set password).
   Purely structural: geometry Mantine style props cannot express, plus the
   mobile overrides from the artboard. Sizing goes through Mantine's own CSS
   variables rather than its internal class names. */

.w0q9ezdVT_TYHY7OJHNw {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 48px 16px 56px;
}

.xcmSCpsTfInuBNmPPigc {
    font-size: 26px;
    line-height: 1.3;
    letter-spacing: -0.01em;
}

/* --card-pad is read by page stylesheets (e.g. Login's key strip and form pad
   themselves by it on a flush card), so it must stay a custom property, not a literal. */
.N9ZvUufP6S6lLzuhyfoH {
    --card-pad: 30px;
    padding: var(--card-pad);
}

@media (max-width: 48em) {
    .w0q9ezdVT_TYHY7OJHNw {
        padding: 24px 0 28px;
        align-items: flex-start;
    }

    .xcmSCpsTfInuBNmPPigc {
        font-size: 22px;
    }

    .N9ZvUufP6S6lLzuhyfoH {
        --card-pad: 20px;
        padding: 24px var(--card-pad);
        border-radius: 0;
        box-shadow: none;
        border-top: 1px solid var(--mantine-color-gray-2);
        border-bottom: 1px solid var(--mantine-color-gray-2);
    }
}

/* Two classes, so it beats .card's padding at either breakpoint regardless of order. */
.N9ZvUufP6S6lLzuhyfoH.L399dHYWUeGh7BdRAUnE {
    padding: 0;
}
`, "",{"version":3,"sources":["webpack://./Components/PublicAuthShell.module.css"],"names":[],"mappings":"AAAA;;;oDAGoD;;AAEpD;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;yFACyF;AACzF;IACI,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI;QACI,oBAAoB;QACpB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,6BAA6B;QAC7B,gBAAgB;QAChB,gBAAgB;QAChB,iDAAiD;QACjD,oDAAoD;IACxD;AACJ;;AAEA,uFAAuF;AACvF;IACI,UAAU;AACd","sourcesContent":["/* Chrome shared by every logged-out screen (login, password reset, set password).\n   Purely structural: geometry Mantine style props cannot express, plus the\n   mobile overrides from the artboard. Sizing goes through Mantine's own CSS\n   variables rather than its internal class names. */\n\n.shell {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 48px 16px 56px;\n}\n\n.title {\n    font-size: 26px;\n    line-height: 1.3;\n    letter-spacing: -0.01em;\n}\n\n/* --card-pad is read by page stylesheets (e.g. Login's key strip and form pad\n   themselves by it on a flush card), so it must stay a custom property, not a literal. */\n.card {\n    --card-pad: 30px;\n    padding: var(--card-pad);\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n    .shell {\n        padding: 24px 0 28px;\n        align-items: flex-start;\n    }\n\n    .title {\n        font-size: 22px;\n    }\n\n    .card {\n        --card-pad: 20px;\n        padding: 24px var(--card-pad);\n        border-radius: 0;\n        box-shadow: none;\n        border-top: 1px solid var(--mantine-color-gray-2);\n        border-bottom: 1px solid var(--mantine-color-gray-2);\n    }\n}\n\n/* Two classes, so it beats .card's padding at either breakpoint regardless of order. */\n.card.flush {\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"shell": `w0q9ezdVT_TYHY7OJHNw`,
	"title": `xcmSCpsTfInuBNmPPigc`,
	"card": `N9ZvUufP6S6lLzuhyfoH`,
	"flush": `L399dHYWUeGh7BdRAUnE`
};
export default ___CSS_LOADER_EXPORT___;
